module.exports = {
    gtm: {
        module: 'gtm',
        service: 'GtmService',
    },
    dtm: {
        module: 'dtm',
        service: 'DtmService',
    },
    tealium: {
        module: 'tealium',
        service: 'TealiumService',
    },
};



// WEBPACK FOOTER //
// ./src/analytics/tag-managers.constants.js